import { render, staticRenderFns } from "./HotelsSortSelect.vue?vue&type=template&id=60051453"
import script from "./HotelsSortSelect.vue?vue&type=script&lang=js"
export * from "./HotelsSortSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports